import { render, staticRenderFns } from "./ProviderProfileForm.vue?vue&type=template&id=225050e1&scoped=true&"
import script from "./ProviderProfileForm.vue?vue&type=script&lang=js&"
export * from "./ProviderProfileForm.vue?vue&type=script&lang=js&"
import style0 from "./ProviderProfileForm.vue?vue&type=style&index=0&id=225050e1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225050e1",
  null
  
)

export default component.exports